export default function isWeekend(day: any){
    return day.day() > 5 || day.day() < 1;
}
